import { Injectable } from '@angular/core';
import { StartupInfos_ExecutionWorkflows, Model_Workflow } from 'src/app/app.models';
import { WorkflowService } from './workflow.service';
import { UnitOfWorkOfflineDao } from '../../daos/unitofwork-offline.dao';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class WorkflowOfflineService extends WorkflowService {
    constructor(
        private _unitOfWork: UnitOfWorkOfflineDao,
        private _httpClient: HttpClient,
    ) {
        super();
    }

    doGetStartupInfosAction() {
        return new Promise<StartupInfos_ExecutionWorkflows>(async (resolve, reject) => {
            var startupInfos = new StartupInfos_ExecutionWorkflows();
            startupInfos.WORKFLOWS = await this._unitOfWork.workflowDao.doGetWorkflowsAction();
            //startupInfos.WORKFLOWS = await this._httpClient.get<Model_Workflow[]>('https://appassets.androidplatform.net/api/Workflow/doGetWorkflowsAction_Workflow', { headers: { 'Access-Control-Allow-Origin': '*' } }).toPromise();
            resolve(startupInfos);
        });
    }

    doGetWorkflowByNumAction(_numWorkflow: string) {
        return new Promise<Model_Workflow>(async (resolve, reject) => {
            const workflow = await this._unitOfWork.workflowDao.doGetWorkflowAction(_numWorkflow); 
            if (workflow === undefined) {
                reject('Impossible de récupérer le workflow. Veuillez synchroniser l\'application.');
                return;
            }
            resolve(workflow);
        });
    }
}